<div *ngIf="hasWeekRegistrations" data-test="flock-overview-week-registration">
  <div class="flock-overview-week-registration__toolbar flex--row-reverse column-reverse">
    <div
      class="flock-overview-week-registration__filters spacing--margin-half-left"
      *ngIf="isDetailedView && !isLtLgBreakpoint"
    >
      <agr-filter
        class="border-none"
        [config]="viewFilterConfig"
        (dialogSaved)="viewFilterDialogSaved($event)"
        [disableDefaultOnClear]="true"
        (clear)="clearViewFilters()"
      >
      </agr-filter>
    </div>

    <div
      *ngIf="!isLtLgBreakpoint"
      class="flock-overview-week-registration__detailed-toggle spacing--margin-left"
    >
      <mat-slide-toggle
        [hideIcon]="true"
        color="primary"
        class="text--small"
        data-test="flock-overview-week-registration__detailed-toggle"
        [checked]="isDetailedView"
        (change)="toggleIsDetailedView()"
      >
        {{ 'flock-overview.week-registrations.view-filters.detailed' | translate }}
      </mat-slide-toggle>
    </div>

    <div *ngIf="flockVariant === flockVariantEnum.Layer">
      <button
        mat-stroked-button
        color="primary"
        (click)="openChartSettings()"
        data-test="flock-overview-week-registration__settings"
      >
        <mat-icon>settings</mat-icon>
        {{ 'flock-overview.week-registrations.filters.title' | translate }}
      </button>
    </div>

    <div class="margin-right-auto">
      <button
        mat-flat-button
        class="spacing--margin-right"
        (click)="downloadTemplate()"
        data-test="panel--daily-performance__upload"
      >
        <mat-icon>file_download</mat-icon>
        {{ 'flock-overview.week-registrations.weekregistration-download' | translate }}
      </button>

      <button mat-button (click)="uploadCSV()" data-test="panel--daily-performance__upload">
        <mat-icon>cloud_upload</mat-icon>
        {{ 'flock-overview.week-registrations.weekregistration-upload' | translate }}
      </button>

      <mat-form-field
        *ngIf="!isDetailedView || isLtLgBreakpoint"
        class="flock-overview-week-registration__week-navigator"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <mat-label>
          {{ 'flock-overview.week-registrations.jump-to-week' | translate }}
        </mat-label>
        <input
          id="flock-overview-week-registration-week-navigator"
          matInput
          type="text"
          [attr.aria-label]="'flock-overview.week-registrations.jump-to-week' | translate"
          [value]="weekNavigatorDisplayValue"
          [matAutocomplete]="weekNavigatorAutocomplete"
          (input)="onWeekNavigatorInput($event)"
          (focus)="showAllWeekNavigatorOptions()"
          (keyup.enter)="jumpToNavigatorWeek()"
          autocomplete="off"
          data-test="flock-overview-week-registration__week-navigator"
        />
        <mat-autocomplete
          #weekNavigatorAutocomplete="matAutocomplete"
          (optionSelected)="onWeekNavigatorOptionSelected($event.option.value)"
        >
          <mat-option
            *ngFor="let weekOption of filteredWeekNavigatorOptions"
            [value]="formatWeekNavigatorValue(weekOption)"
          >
            {{ formatWeekNavigatorValue(weekOption) }}
          </mat-option>
        </mat-autocomplete>
        <button
          mat-icon-button
          matSuffix
          type="button"
          color="primary"
          (click)="jumpToNavigatorWeek()"
          [attr.aria-label]="'flock-overview.week-registrations.jump-to-week' | translate"
          data-test="flock-overview-week-registration__week-navigator-button"
        >
          <mat-icon>keyboard_return</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>

  <div
    class="flock-overview-week-registration__navigation-row"
    *ngIf="!isDetailedView || isLtLgBreakpoint"
  >
    <div class="flock-overview-week-registration__pagination">
      <button
        mat-icon-button
        (click)="onButtonLeft()"
        [disabled]="!hasPrevious()"
        data-test="flock-overview-week-registration__buttonLeft"
      >
        <mat-icon class="icon-large">keyboard_arrow_left</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="onButtonRight()"
        [disabled]="!hasNext()"
        data-test="flock-overview-week-registration__buttonRight"
      >
        <mat-icon class="icon-large">keyboard_arrow_right</mat-icon>
      </button>
    </div>

    <mat-select
      class="flock-overview-week-registration__sort-by"
      [hideSingleSelectionIndicator]="true"
      data-test="flock-overview-week-registration__sortBy"
      [value]="sortBy"
      (selectionChange)="sortByChanged.emit($event.value)"
    >
      <mat-option value="asc">
        {{ 'flock-overview.week-registrations.sortByAscending' | translate }}
      </mat-option>
      <mat-option value="desc">
        {{ 'flock-overview.week-registrations.sortByDescending' | translate }}
      </mat-option>
    </mat-select>
  </div>

  <ng-container *ngIf="!!flockWeekData">
    <div
      class="flex--row flex--gutter"
      data-test="flock-overview-week-registration__items"
      *ngIf="!isDetailedView || isLtLgBreakpoint; else detailedView"
    >
      <ng-container *ngFor="let weekData of flockWeekData">
        <app-flock-overview-week-registration-item
          *ngIf="flockVariant === flockVariantEnum.Layer; else breederWeekRegistrationItem"
          data-test="flock-overview-week-registration__item"
          class="flock-overview-week-registration__item flex--column flex__child--auto"
          [flockWeekData]="weekData"
          [flockWeekDataSeries]="flockWeekDataSeries"
          [flock]="flock"
          (editClicked)="editClicked.emit($event)"
          (deleteClicked)="deleteClicked.emit($event)"
        >
        </app-flock-overview-week-registration-item>
        <ng-template #breederWeekRegistrationItem>
          <app-breeder-flock-overview-week-registration-item
            data-test="flock-overview-week-registration__item"
            class="flock-overview-week-registration__item flex--column flex__child--auto"
            [flockWeekData]="weekData"
            [flockWeekDataSeries]="flockWeekDataSeries"
            [flock]="flock"
            (editClicked)="editClicked.emit($event)"
            (deleteClicked)="deleteClicked.emit($event)"
          >
          </app-breeder-flock-overview-week-registration-item>
        </ng-template>
      </ng-container>
    </div>
    <ng-template #detailedView>
      <app-flock-overview-week-registration-detailed-wrapper
        data-test="flock-overview-week-registration__detailed"
        [flockWeekDataSet]="flockWeekDataSet"
        [flock]="flock"
        [flockVariant]="flockVariant"
      >
      </app-flock-overview-week-registration-detailed-wrapper>
    </ng-template>
  </ng-container>
</div>
